
const state = {
    selectIndex: null
};

const getters = {
    getSelectIndex(state) {
        return state.selectIndex;
    }
};
const mutations = {
    setSelectIndex(state, data) {
        state.selectIndex = data;
    }
};
const actions = {};

export default { state, getters, mutations, actions };
